import { type MaintenanceCustomerListQuery } from '@gb-ticket/shared-types';

import { toSearchParams } from '@/lib/format';
import { MAINTENANCE_CUSTOMERS_PATH } from '@/products/maintenance/maintenance-paths';

const EMPTY: MaintenanceCustomerListQuery = {
  page: 1,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'asc',
};

export function maintenanceCustomerListPath(
  patch: Partial<MaintenanceCustomerListQuery> = {},
): string {
  const merged = { ...EMPTY, ...patch };
  return `${MAINTENANCE_CUSTOMERS_PATH}${toSearchParams({
    page: merged.page,
    pageSize: merged.pageSize,
    sortBy: merged.sortBy,
    sortOrder: merged.sortOrder,
    q: merged.q,
    isActive: merged.isActive === undefined ? undefined : String(merged.isActive),
  })}`;
}

const SEARCH_KEYS = ['page', 'pageSize', 'sortBy', 'sortOrder', 'q', 'isActive'] as const;

export function maintenanceCustomerListQueryFromSearch(
  search: string,
): Partial<MaintenanceCustomerListQuery> | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  if ([...params.keys()].length === 0) {
    return null;
  }
  const raw: Record<string, string> = {};
  for (const key of SEARCH_KEYS) {
    const value = params.get(key);
    if (value) {
      raw[key] = value;
    }
  }
  if (Object.keys(raw).length === 0) {
    return null;
  }
  return {
    page: raw.page ? Number(raw.page) || 1 : 1,
    pageSize: raw.pageSize ? Number(raw.pageSize) || 25 : 25,
    sortBy: (raw.sortBy as MaintenanceCustomerListQuery['sortBy']) || 'name',
    sortOrder: raw.sortOrder === 'desc' ? 'desc' : 'asc',
    q: raw.q,
    isActive: raw.isActive === 'true' ? true : raw.isActive === 'false' ? false : undefined,
  };
}
